module.exports = __webpack_public_path__ + "img/img-mainbanner-bg-m.6347dd79.png";